import Home from '@/assets/icons/home.svg'
import About from '@/assets/icons/about.svg'
import projects from '@/assets/icons/projects.svg'
import instagram from '@/assets/icons/instagram.svg'
import PapelAmassadoIcon from '@/components/PapelAmassadoIcon'
import PacketShieldIcon from '@/components/PacketShieldIcon'
import PapyrusIcon from '@/components/PapyrusIcon'

const routes = [
  {
    title: 'Home',
    route: '/',
    icon: Home
  },
  {
    title: 'Projetos',
    route: '/projects',
    icon: projects
  },
  {
    title: 'Sobre mim',
    route: '/about',
    icon: About
  },
  // {
  //   route: '/#2',
  //   icon: FiAward
  // },
  {
    title: 'Instagram',
    route: 'https://www.instagram.com/solrachix',
    icon: instagram,
    socialIcon: true,
    isExternal: true
  },
  {
    title: 'PacketShield',
    route: 'https://packetshield.solrachix.com/',
    icon: PacketShieldIcon,
    socialIcon: true,
    isExternal: true
  },
  {
    title: 'Papyrus SDK',
    route: 'https://solrachix.github.io/Papyrus/',
    icon: PapyrusIcon,
    socialIcon: true,
    isExternal: true
  },
  {
    title: 'Papel Amassado',
    route: 'https://papel-amassado.com/',
    icon: PapelAmassadoIcon,
    socialIcon: true,
    isExternal: true
  }
  // {
  //   title: 'Proposta',
  //   route: '/proposal',
  //   icon: proposals
  // }
]

export default routes
